import {CustomFlowbiteTheme} from "flowbite-react";

export const labelTheme: CustomFlowbiteTheme["label"] = {
    root: {
        base: "text-sm font-medium text-catapult-black dark:text-catapult-white",
        colors: {
            gray:"dark:text-catapult-white",
            failure: "text-catapult-red-600" +
                " dark:text-catapult-red-400"
        }
    }
}